jQuery(document).ready(function () {
//initialize api.
    var base_url = "https://api-fai.analyticom.de";
    var competitionId = 30664819;
    var team_id = 56418;
    var page_size_small = 3;
    var teamIdFilter = 10614;
    var api_mens_senior_card_fixture = base_url + "/api/live/competition/" + competitionId + "/matches/paginated/future/1/" + team_id + "?page=1&pageSize=" + page_size_small + "&teamIdFilter=" + teamIdFilter;
    var api_key = "8f03d750e912f7ff66d3b5eb1ca39f66d762785059470f85723d7513a71ae097106e5b8d3a548b85e60d49ec9fec2471e2086e9cc95f2f22f741f1962d3db004";
    var url_faiconnect = "https://faiconnect.ie/file?id=";
//Fixtures section.
    jQuery.ajax({
        url: api_mens_senior_card_fixture,
        type: "get",
        headers: {
        "API_KEY": api_key,
        },
        dataType: "json",
        success: function (response) {
        //console.log(response);
        var content = "";
        if (!jQuery.trim(response.result) || jQuery.trim(response.result) == null || jQuery.trim(response.result) == undefined) {
            content += "<div class='empty-val'><p><strong>No results found.</strong></p></div>";
        }
        else {
            jQuery.each(response.result, function (key, value) {
            var home_team_crest = url_faiconnect + value?.homeTeam.picture;
            var away_team_crest = url_faiconnect + value?.awayTeam.picture;
            var competition = value?.competition.name;
            var match_full_date = new Date(value?.dateTimeUTC).toDateString();
            //var match_time = new Date(value?.dateTimeUTC).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
            var match_time = new Date(value?.dateTimeUTC).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
            content += "<div class='wrapper-fixture'>";
            content += "<div class='card-content'>";
            content += "<div class='match-date'><p>" + match_full_date + "</p></div>";
            content += "<div class='match-detail'>";
            content += "<div class='team'><span>" + value?.homeTeam.name + "</span><img id='team-crest' class='team-crest home' src='" + home_team_crest + "' alt='" + value?.homeTeam.place + "'/></div>";
            content += "<div class='current-result'><span class='match-time'>" + match_time + "</span></div>";
            content += "<div class='team'><img id='team-crest' class='team-crest away' src='" + away_team_crest + "' alt='" + value?.awayTeam.place + "'/><span>" + value?.awayTeam.name + "</span></div>";
            content += "</div>";
            content += "<div class='match-date'><p>" + competition + "</p></div>";
            content += "</div>";
            content += "</div>";
            });
        }
        //insert content.
        jQuery('.container-card-fixture').html(content);
        },
        error: function (errorThrown) {
        console.log(errorThrown);
        },
    });
});